/**
 * **「导出」这件事的通用文案** —— 两个入口**共用**（🔴 铁律 24：一个机制一个归属）
 *
 * | 入口 | 位置 | 实现 |
 * |---|---|---|
 * | 导出流水 CSV（**当前筛选**） | 流水页工具条（`AC-N4.4`） | C 域 |
 * | 导出流水 CSV（全部）/ 全量备份 JSON | 设置页「数据主权区」 | C 域 / N 域 |
 *
 * ## 🔴 为什么单独一个文件
 *
 * 「导出中… / 导出失败：xxx / 已导出 xxx.json」这三条反馈在**两处都会出现**。
 * 若各写一份（`journal-labels.ts` 与 `sovereignty-labels.ts` 各存一份），
 * 两处就会慢慢漂移（一处改"导出失败"另一处还写"下载失败"）—— 那正是本项目反复防的**双实现**。
 * ⇒ 通用反馈归本文件；**各区特有**的关键词（如「数据主权区」的标题与说明）留在各自的 labels 里。
 */

/** 按钮忙碌态文案（两个入口共用） */
export const EXPORT_BUSY_LABEL = '导出中…';

/** 失败前缀（后接服务端 `message` 原文 —— 端侧不自己编错误文案，见 `api/http.ts` 文件头） */
export const EXPORT_FAILED_PREFIX = '导出失败：';

/** 🔴 **文件名回显** —— 用户要能确认自己拿到的是什么（而不是只看到"成功"两个字） */
export function exportedNote(fileName: string): string {
  return `已导出 ${fileName}`;
}

/** 流水页工具条按钮（`AC-N4.4`：导出**当前筛选**结果 —— 入口在本页，实现归 C 域） */
export const EXPORT_CURRENT_ACTION = '导出当前筛选';
